// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"719":"e9935461","829":"157dcb7c"}[chunkId] + ".chunk.js";
};